import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import queryString from 'query-string';
import { Formik } from 'formik';

import LayoutModal from 'components/_parts/atoms/modal';
import Wrapper from 'components/_parts/atoms/wrapper';
import Button from 'components/_parts/atoms/button';

import { validationBp } from 'validation/BisnisProcess';
import {
  HIT_ADD_TREE,
  HIT_CREATE_BS,
  HIT_CREATE_CHILD,
  HIT_UPDATE_BS,
  UPDATE_LEVEL_PROCEESS_PARENT,
} from 'redux/actions/business_process';
import { bisnisProcess } from 'components/types/businessProcess';
import { useTranslation } from 'react-i18next';
import { GET_WLA_LIST_TEMPLATE } from 'redux/actions/wla';
import { initialValues } from './parts/initialValues';
import RightContent from './parts/rightContent';
import LeftContent from './parts/leftContent';
import CleanData from './parts/cleanData';
import ListData from './parts/listDatas';
import useFetch from './parts/useFetch';
import TitleBp from './parts/titleBp';

function ModalLayout({
  modal,
  setModal,
  typeModal,
  type,
  child,
  typeTree,
  datas,
}: bisnisProcess) {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const { tab: paramTab } = queryString.parse(location.search);
  const { state } = location;
  const [initialValuesState, setInitialValuesState] = useState(initialValues);
  const { detailBs, listTemplate, levelParent } = ListData();
  const { getLoadOptions } = useFetch({
    datas, modal, paramTab, typeModal, levelParent,
  });
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (modal && datas !== undefined) {
      // DATA EDIT
      const newList = listTemplate?.map((value: any) => ({
        activity_name: value.activity_name,
        standart_waktu: value.standart_waktu / 3600,
      }));

      setInitialValuesState({
        ...initialValues, ...detailBs, category: datas.type, dataWorkload: newList,
      });
    } else if (child !== undefined && typeTree === undefined) {
      // DATA CHILD
      setInitialValuesState({
        ...initialValues, parent_id: child.process_id, level: Number(child.level + 1),
      });
      dispatch({
        type: UPDATE_LEVEL_PROCEESS_PARENT,
        payload: Number(child.level),
      });
    } else if (child !== undefined && typeTree !== undefined) {
      // DATA ADD NEXT
      setInitialValuesState({
        ...initialValues, level: Number(child.level),
      });
      dispatch({
        type: UPDATE_LEVEL_PROCEESS_PARENT,
        payload: Number(child.level - 1),
      });
    }
  }, [modal, datas, detailBs, listTemplate]);

  const handleSubmit = async (values: any) => {
    const {
      data, dataChild, dataTree, dataEdit,
    } = CleanData({
      values,
      child,
      typeTree,
      typeModal,
    });

    if (datas !== undefined) {
      dispatch({
        type: HIT_UPDATE_BS,
        payload: {
          data: dataEdit,
          board_id: localStorage.getItem('board_id'),
          dispatch,
          data_form: values.dataWorkload,
          process_id: values.process_id,
        },
      });
    } else if (
      child === undefined
      && typeTree === undefined
      && values.level === 1
    ) {
      dispatch({
        type: HIT_CREATE_BS,
        payload: {
          body: data,
          dispatch,
          data_form: values.dataWorkload,
          state,
        },
      });
    } else if (typeTree !== undefined && child !== undefined) {
      dispatch({
        type: HIT_ADD_TREE,
        payload: {
          body: dataTree,
          board_id: localStorage.getItem('board_id'),
          data_form: values.dataWorkload,
        },
      });
    } else {
      dispatch({
        type: HIT_CREATE_CHILD,
        payload: {
          data: dataChild,
          board_id: localStorage.getItem('board_id'),
          data_form: values.dataWorkload,
          dispatch,
        },
      });
    }

    setInitialValuesState(initialValues);
    setModal(false);
  };

  const handleClear = () => {
    setInitialValuesState(initialValues);
    dispatch({
      type: GET_WLA_LIST_TEMPLATE,
      payload: [],
    });
    dispatch({
      type: UPDATE_LEVEL_PROCEESS_PARENT,
      payload: 1,
    });
  };
  return (
    <LayoutModal type="bispro_revamp" modal={modal}>
      <Wrapper
        setModal={setModal}
        handleClear={handleClear}
        style={{ height: '100%', padding: '30px 45px' }}
      >
        <Formik
          initialValues={initialValuesState}
          validationSchema={validationBp({ t })}
          enableReinitialize
          onSubmit={handleSubmit}
        >
          {({ values, handleSubmit }) => (
            <form
              className="custom_layout_create"
              style={{ position: 'relative' }}
              onSubmit={handleSubmit}
            >
              <TitleBp
                child={child}
                typeModal={typeModal}
                typeTree={typeTree}
                datas={datas}
                t={t}
                tabValue={tabValue}
                setTabValue={setTabValue}
                parentLevel={values.level}
              />
              {tabValue === 0
                ? (
                  <LeftContent
                    child={child}
                    typeModal={typeModal}
                    typeTree={typeTree}
                    datas={datas}
                    t={t}
                    loadOption={getLoadOptions}
                  />
                )
                : (
                  <RightContent
                    paramTab={paramTab}
                    typeTree={typeTree}
                    type={type}
                    t={t}
                  />
                )}
              <div className="button_library-position">
                <Button
                  style={{
                    backgroundColor: 'transparent',
                    color: '#3D5AFE',
                    width: '90px',
                    height: '40px',
                    marginLeft: 'auto',
                  }}
                  func={() => {
                    setModal(false);
                    handleClear();
                  }}
                >
                  {t('biz_process.cancel')}
                </Button>
                <Button
                  style={{ width: '90px', height: '40px' }}
                  func={handleSubmit}
                >
                  {t('biz_process.save')}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </Wrapper>
    </LayoutModal>
  );
}

export default ModalLayout;
